import { Fragment } from "react"
import { useSelector } from "react-redux"
import { Grid, Typography, Box } from "@mui/material"
import InProcessHeader from "./InProcessHeader"
import InProcessFooter from "./InProcessFooter"

import { BottomPushStyles, CharacteristicBlankSmallStyles, CharacteristicBlankStyles, CharacteristicCellBlankStyles, CharacteristicCellKeyStyles, CharacteristicCellStyles, CharacteristicEntry1Styles, CharacteristicEntryNum1Styles, CharacteristicEntryNum2Styles, CharacteristicEvenSpaceStyles, CharacteristicKeyStyles, CharacteristicStyles, ControlCharacteristicEvenSpaceSmallStyles, ControlCharacteristicEvenSpaceStyles, ExcludedCoverStyles, ExcludedCoverTitleStyles, ExcludedOperationStyles, PageBreakNoStyles, PageBreakStyles } from "./styles/OutputStyles"

function OperationsCover({ output }) {
    const displayValue = (value) =>
        Array.isArray(value) ? [...new Set(value)].join(", ") : value

    return (
        <Box sx={ExcludedCoverStyles}>
            <Typography sx={ExcludedCoverTitleStyles}>
                Print summary for item {displayValue(output.partNumber)}
                {" "}
                revision {displayValue(output.partRevision)}
            </Typography>
            <Typography sx={ExcludedOperationStyles}>
                Printed operations: {output.operation.join(", ")}
            </Typography>
            <Typography sx={ExcludedOperationStyles}>
                Not printed operations: {output.excluded.join(", ")}
            </Typography>
        </Box>
    )
}

function InProcessReport({ output, hasFollowingOutput }) {
    const numDates = [1, 2, 3, 4, 5]
    return (
        <>
            {[...output.characteristics]
                .sort((a, b) => a.SequenceNumber - b.SequenceNumber)
                .map((item, index) => (
                    <Fragment key={item.CharacteristicId ?? index}>
                        {((index + 1) % output.numCells === 1 ||
                            index === 0) && (
                            <Box>
                                <InProcessHeader output={output} />
                            </Box>
                        )}
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="stretch"
                        >
                            <Grid
                                item
                                size={6}
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="stretch"
                            >
                                <Grid
                                    item
                                    size={4}
                                    sx={
                                        item.Key
                                            ? CharacteristicCellKeyStyles
                                            : CharacteristicCellStyles
                                    }
                                >
                                    <Typography
                                        multiline
                                        fullWidth
                                        sx={
                                            item.Key
                                                ? CharacteristicKeyStyles
                                                : CharacteristicStyles
                                        }
                                        align="center"
                                    >
                                        {item.Key ? "ëÊÄØê " : null}
                                        {item.Characteristic
                                            ? item.Characteristic
                                            : ""}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    size={2}
                                    sx={CharacteristicCellBlankStyles}
                                >
                                    <Typography
                                        multiline
                                        
                                        sx={CharacteristicBlankStyles}
                                        align="left"
                                    ></Typography>
                                </Grid>
                                <Grid
                                    item
                                    size={2}
                                    sx={CharacteristicCellBlankStyles}
                                >
                                    <Typography
                                        multiline
                                        
                                        sx={CharacteristicBlankStyles}
                                        align="left"
                                    >
                                        {item.Frequency}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    size={2}
                                    sx={CharacteristicCellBlankStyles}
                                >
                                    <Typography
                                        multiline
                                        
                                        sx={CharacteristicBlankStyles}
                                        align="left"
                                    >
                                        {item.InspectionMethod}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    size={1}
                                    sx={CharacteristicCellBlankStyles}
                                >
                                    <Typography
                                        multiline
                                        
                                        sx={CharacteristicBlankStyles}
                                        align="left"
                                    >
                                        {item.Tool ? item.Tool : ""}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    size={1}
                                    sx={CharacteristicCellBlankStyles}
                                >
                                    {!output.ppap ? (
                                        <Typography
                                            
                                            multiline
                                            sx={
                                                CharacteristicBlankStyles
                                            }
                                            align="left"
                                        >
                                            {item.Location ? item.Location : ""}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            
                                            multiline
                                            sx={
                                                CharacteristicBlankSmallStyles
                                            }
                                            align="left"
                                        >
                                            {item.ControlMethod}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                size={6}
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="stretch"
                            >
                                {!output.ppap ? null : (
                                    <>
                                        <Grid
                                            item
                                            sx={
                                                ControlCharacteristicEvenSpaceSmallStyles
                                            }
                                        >
                                            <Typography
                                                
                                                align="left"
                                                sx={
                                                    CharacteristicBlankStyles
                                                }
                                            >
                                                {item.Reaction
                                                    ? item.Reaction
                                                    : "See Q.E. or Supervisor"}
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            sx={
                                                ControlCharacteristicEvenSpaceSmallStyles
                                            }
                                        >
                                            <Typography
                                                
                                                multiline
                                                align="center"
                                                sx={
                                                    CharacteristicBlankStyles
                                                }
                                            >
                                                {item.Location
                                                    ? item.Location
                                                    : ""}
                                            </Typography>
                                        </Grid>
                                    </>
                                )}
                                {numDates.map((item) => (
                                    <Grid
                                        item
                                        direction="column"
                                        justifyContent="flex-start"
                                        alignItems="stretch"
                                        sx={
                                            !output.ppap
                                                ? CharacteristicEvenSpaceStyles
                                                : ControlCharacteristicEvenSpaceStyles
                                        }
                                    >
                                        <Grid
                                            item
                                            size={12}
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="stretch"
                                            sx={
                                                CharacteristicEntry1Styles
                                            }
                                        >
                                            <Typography
                                                
                                                sx={
                                                    CharacteristicEntryNum1Styles
                                                }
                                                align="left"
                                            >
                                                1
                                            </Typography>
                                            <Typography
                                                
                                                sx={
                                                    CharacteristicEntry1Styles
                                                }
                                                align="left"
                                                fullWidth
                                            ></Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            size={6}
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="stretch"
                                        >
                                            <Typography
                                                
                                                sx={
                                                    CharacteristicEntryNum2Styles
                                                }
                                                align="left"
                                            >
                                                2
                                            </Typography>
                                            <Typography
                                                
                                                align="left"
                                                fullWidth
                                            ></Typography>
                                        </Grid>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        {(index + 1) % output.numCells === 0 &&
                            index !== 0 &&
                            index !== output.characteristics.length - 1 && (
                                <Box sx={BottomPushStyles}>
                                    <InProcessFooter output={output} />
                                    <Typography
                                        sx={PageBreakStyles}
                                        noWrap
                                        align="right"
                                    >
                                        {`Page ${Math.ceil(
                                            (index + 1) / output.numCells
                                        )} of ${Math.ceil(
                                            output.characteristics.length /
                                                output.numCells
                                        )}`}
                                    </Typography>
                                </Box>
                            )}
                        {index === output.characteristics.length - 1 && (
                            <Box sx={BottomPushStyles}>
                                <InProcessFooter output={output} />
                                <Typography
                                    sx={
                                        hasFollowingOutput
                                            ? PageBreakStyles
                                            : PageBreakNoStyles
                                    }
                                    noWrap
                                    align="right"
                                >
                                    {`Page ${Math.ceil(
                                        output.characteristics.length /
                                            output.numCells
                                    )} of ${Math.ceil(
                                        output.characteristics.length /
                                            output.numCells
                                    )}`}
                                </Typography>
                            </Box>
                        )}
                    </Fragment>
                ))}
        </>
    )
}

function InProcessContent() {
    const output = useSelector((state) => state.output)
    const hasMultipleOutputs = Array.isArray(output.characteristics?.[0])

    const outputs = hasMultipleOutputs
        ? output.characteristics.map((characteristics, index) =>
              Object.fromEntries(
                  Object.entries(output).map(([field, value]) => [
                      field,
                      field === "characteristics"
                          ? characteristics
                          : Array.isArray(value)
                          ? value[index]
                          : value
                  ])
              )
          )
        : [output]

    return (
        <>
            {Array.isArray(output.operation) && (
                <OperationsCover output={output} />
            )}
            {outputs.map((currentOutput, index) => (
                <InProcessReport
                    key={
                        currentOutput.characteristics?.[0]?.InspectionId ??
                        index
                    }
                    output={currentOutput}
                    hasFollowingOutput={index < outputs.length - 1}
                />
            ))}
        </>
    )
}

export default InProcessContent
